import { getSuggestedProductsFilters } from '~/grid/utils/cioUtils';

import { TOP_SUGGESTIONS_COUNT } from '../constants/cioConstants';

/**
 * @function getCioSuggestionsAndProducts
 * @description Fetches suggested terms and products from Constructor.io's autocomplete API
 * @param {Object} cioClient - Constructor.io client instance
 * @param {String} query - Search query
 * @param {Boolean} isVip - user is vip
 * @param {Boolean} isElite - user is elite
 * @param {Boolean} isSecondarySite - the user is viewing a secondary site, like the outlets site
 * @param {Number} productCount - Number of products to query
 * @return {Object} contains autosuggest search terms, top products based on the autosuggest, and various request info for debugging
 */
export const getCioSuggestionsAndProducts = ({
  cioClient,
  query,
  isVip,
  isElite,
  secondarySite,
  productCount,
}) => {
  const productFilters = getSuggestedProductsFilters({
    isElite,
    isVip,
    shouldShowWarehouseProducts: Boolean(secondarySite),
  });

  return cioClient.autocomplete.getAutocompleteResults(query, {
    resultsPerSection: {
      Products: productCount,
      'Search Suggestions': TOP_SUGGESTIONS_COUNT,
    },
    filtersPerSection: {
      Products: productFilters,
    },
  });
};
